import * as types from 'Redux/types/payments';

import yup from 'yup';
import { requestOptions } from 'Helpers/Graphql';

import { trackCheckout, trackPurchase } from 'Helpers/Tracking';
import { calculateCartPrice } from 'Helpers/Cart';

import updateBillingInformationMutation from 'Gql/mutations/payments.updateBillingInformation.mutation';
import purchaseByBraintreeMutation from 'Gql/mutations/payments.byBraintree.mutation';
import purchaseCreditPackageByBraintreeMutation from 'Gql/mutations/payments.creditPackageByBraintree.mutation';
import purchaseByCreditsMutation from 'Gql/mutations/payments.byCredits.mutation';
import braintreeClientTokenQuery from 'Gql/queries/braintree.clientToken.query';
import billingInformationQuery from 'Gql/queries/billing.information.query';

import { me } from 'Redux/actions/user';

export const getBraintreeToken = (params) => (dispatch) => {
    params = {
        ...params,
    };

    return requestOptions({
        req: null,
        type: types.GET_BRAINTREE_TOKEN,
        onRetry: getBraintreeToken,
        name: 'braintreeClientToken',
        validationSchema: yup.object().shape({
            data: yup.object().shape({
                braintreeClientToken: yup.string().required()
            }).required()
        }),
        params: params,
        requestParams: {},
        query: braintreeClientTokenQuery
            .replace('%name%', 'braintreeClientToken')
    })
        .then(response => {
            process.rollbar.info('Checkout - getBraintreeToken', response);
            return response;
        });
};

export const fetchBillingData = (params) => (dispatch) => {
    params = {
        ...params,
    };

    return requestOptions({
        req: null,
        type: types.FETCH_BILLING_DATA,
        onRetry: fetchBillingData,
        name: 'billingData',
        validationSchema: yup.object().shape({
            data: yup.object().shape({
                me: yup.object().shape({
                    ownedBusiness: yup.object().required(),
                    currentBrand: yup.object().shape({
                        business: yup.object().required()
                    }).nullable(true)
                }).required()
            }).required()
        }),
        params: params,
        requestParams: {},
        query: billingInformationQuery
            .replace('%name%', 'billingData')
    })
        .then(response => {
            process.rollbar.info('Checkout - fetchBillingData', response);
            return response;
        });
};

export const clearBillingData = (data) => (dispatch) => {
    return dispatch({ type: types.CLEAR_BILLING_DATA });
};

export const updateBillingData = (params = {}) => (dispatch) => {
    if ((typeof params.private === 'string' && params.private === 'true') || params.private === true) {
        params = {
            firstName: '',
            lastName: '',
            countryCode: '',
            ...params,
            private: true,
        };
    } else {
        params = {
            firstName: '',
            lastName: '',
            countryCode: '',
            companyName: '',
            vatId: '',
            address: '',
            ...params,
            private: false,
        };
    }

    return requestOptions({
        req: null,
        type: types.UPDATE_BILLING_DATA,
        onRetry: updateBillingData,
        name: 'updateBillingData',
        validateSuccess: response => !response.data.updateBillingInformation.errors || !response.data.updateBillingInformation.errors.length,
        validationSchema: yup.object().shape({
            data: yup.object().shape({
                updateBillingInformation: yup.object().required()
            }).required()
        }),
        params: params,
        requestParams: params,
        query: updateBillingInformationMutation
            .replace('%name%', 'updateBillingData')
    })
        .then(response => {
            process.rollbar.info('Checkout - updateBillingData', response);
            return response;
        });
};

export const purchaseByBraintree = (params) => (dispatch) => {
    return requestOptions({
        req: null,
        type: types.PURCHASE_BRAINTREE,
        onRetry: purchaseByBraintree,
        name: 'purchaseByBraintree',
        validationSchema: yup.object().shape({
            data: yup.object().shape({
                purchaseByBraintree: yup.object().required()
            }).required()
        }),
        params: params,
        requestParams: params,
        query: purchaseByBraintreeMutation
            .replace('%name%', 'purchaseByBraintree')
    })
        .then(response => {
            process.rollbar.info('Checkout - purchaseByBraintree', response);

            const cart = process.store.getState().cart;
            let transactionId = response.payload.data.transaction ? response.payload.data.transaction.braintreeId : (new Date()).getTime();

            const price = calculateCartPrice(cart.items, cart.selectedPackage, cart.totalApiPrice);
            let items = cart.items;
            if (cart.selectedPackage) {
                items.push({
                    id: cart.selectedPackage.id,
                    name: 'Credit Package: ' + cart.selectedPackage.name,
                    price: cart.selectedPackage.price,
                    category: 'Credit Package',
                    user: {
                        username: 'Foap'
                    }
                });
            }
            trackCheckout('checkoutPayment', items);
            trackPurchase(transactionId, items, price.total);


            return response;
        });
};

export const purchaseCreditsPackageByBraintree = (params) => (dispatch) => {
    return requestOptions({
        req: null,
        type: types.PURCHASE_CREDITS_BRAINTREE,
        onRetry: purchaseCreditsPackageByBraintree,
        name: 'purchaseCreditsPackageByBraintree',
        validationSchema: yup.object().shape({
            data: yup.object().shape({
                purchaseCreditPackageByBraintree: yup.object().required()
            }).required()
        }),
        params: params,
        requestParams: params,
        query: purchaseCreditPackageByBraintreeMutation
            .replace('%name%', 'purchaseCreditsPackageByBraintree')
    })
        .then(response => {
            process.rollbar.info('Checkout - purchaseCreditsPackageByBraintree', response);

            const cart = process.store.getState().cart;
            let transactionId = response.payload.data.transaction ? response.payload.data.transaction.braintreeId : (new Date()).getTime();

            const price = calculateCartPrice(cart.items, cart.selectedPackage, cart.totalApiPrice);
            let items = cart.items;
            if (cart.selectedPackage) {
                items.push({
                    id: cart.selectedPackage.id,
                    name: 'Credit Package: ' + cart.selectedPackage.name,
                    price: cart.selectedPackage.price,
                    category: 'Credit Package',
                    user: {
                        username: 'Foap'
                    }
                });
            }
            trackCheckout('checkoutPayment', items);
            trackPurchase(transactionId, items, price.total);


            return response;
        });
};

export const purchaseByCredits = (params) => (dispatch) => {
    return requestOptions({
        req: null,
        type: types.PURCHASE_CREDITS,
        onRetry: purchaseByCredits,
        name: 'purchaseByCredits',
        validationSchema: yup.object().shape({
            data: yup.object().shape({
                purchaseCartByCredits: yup.object().required()
            }).required()
        }),
        params: params,
        requestParams: params,
        query: purchaseByCreditsMutation
            .replace('%name%', 'purchaseByCredits')
    })
        .then(response => {
            process.rollbar.info('Checkout - purchaseByCredits', response);

            const cart = process.store.getState().cart;
            trackCheckout('checkoutCredits', cart.items);


            return response;
        });
};



// WEBPACK FOOTER //
// ./src/redux/actions/payments.js